var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./OrdersReservation.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-48144f3b!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OrdersReservation.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Order/OrdersReservation.vue
// module id = 608
// module chunks = 0